<template>
  <carousel
    :perPage="1"
    :paginationPadding="6"
    :paginationSize="6"
    class="w-full mx-auto my-12"
  >
    <slide
      v-for="(image, imageIndex) in images"
      :key="'image-' + imageIndex"
      class="w-full relative"
      :style="aspectRatioPaddingStyle"
    >
      <img
        class="absolute top-0 left-0 w-full h-full object-contain"
        v-lazy="image.src"
        :data-srcset="image.srcset"
      />
    </slide>
  </carousel>  
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ImageCarousel',

  props: ['images'],

  components: {
    Carousel,
    Slide
  },

  computed: {
    aspectRatioPaddingStyle () {
      let widestAspectRatio = -1
      let w, h
      this.images.forEach(i => {
        const ratio = i.dimensions.width / i.dimensions.height
        if (ratio > widestAspectRatio) {
          widestAspectRatio = ratio
          w = i.dimensions.width
          h = i.dimensions.height
        }
      })

      return `padding-top:calc(100%/(${w}/${h}));`
    }    
  }
}
</script>